// Menu click handler - ensures clicks work on both desktop and mobile
// This file handles click events for navigation menu items to toggle submenus
(function() {
  'use strict';

  function isMobile() {
    return window.innerWidth <= 749;
  }
  
  // Prevent hover activation for all menu items
  function preventHover(e) {
    e.stopImmediatePropagation();
    e.preventDefault();
    return false;
  }

  function applyHoverPrevention() {
    const menuItems = document.querySelectorAll('.menu-list__list-item, .menu-list__link');
    menuItems.forEach(item => {
      item.addEventListener('mouseenter', preventHover, { capture: true, passive: false });
      item.addEventListener('pointerenter', preventHover, { capture: true, passive: false });
      item.addEventListener('mouseover', preventHover, { capture: true, passive: false });
    });
  }

  function handleMenuClick(event) {
    const link = event.currentTarget;
    const listItem = link.closest('.menu-list__list-item');
    if (!listItem) return;

    const submenu = listItem.querySelector('.menu-list__submenu');
    if (!submenu) return;

    // Always prevent default navigation if it has children
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    // Close all other open submenus
    document.querySelectorAll('.menu-list__list-item[aria-expanded="true"]').forEach(item => {
        if (item !== listItem) {
            item.removeAttribute('aria-expanded');
            const otherLink = item.querySelector('.menu-list__link');
            if (otherLink) otherLink.setAttribute('aria-expanded', 'false');
            const otherSubmenu = item.querySelector('.menu-list__submenu');
            if (otherSubmenu) otherSubmenu.setAttribute('data-expanded', 'false');
        }
    });

    // Toggle current state
    const isExpanded = listItem.getAttribute('aria-expanded') === 'true';
    const newExpanded = !isExpanded;
    
    link.setAttribute('aria-expanded', newExpanded ? 'true' : 'false');
    
    if (newExpanded) {
      listItem.setAttribute('aria-expanded', 'true');
      submenu.setAttribute('data-expanded', 'true');
      
      // Calculate height for theme's clip-path animation
      const height = submenu.scrollHeight;
      const headerMenu = listItem.closest('header-menu');
      if (headerMenu) {
          headerMenu.style.setProperty('--submenu-height', `${height}px`);
          headerMenu.style.setProperty('--submenu-opacity', '1');
      }
    } else {
      listItem.removeAttribute('aria-expanded');
      submenu.setAttribute('data-expanded', 'false');
      const headerMenu = listItem.closest('header-menu');
      if (headerMenu) {
          headerMenu.style.setProperty('--submenu-height', '0px');
          headerMenu.style.setProperty('--submenu-opacity', '0');
      }
    }

    // Manually trigger theme's activation logic if available
    const headerMenuComponent = link.closest('header-menu');
    if (headerMenuComponent && headerMenuComponent.activate) {
      if (newExpanded) {
        headerMenuComponent.activate(event);
      } else if (headerMenuComponent.deactivate) {
        headerMenuComponent.deactivate(event);
      }
    }
    
    return false;
  }

  function init() {
    applyHoverPrevention();
    
    const links = document.querySelectorAll('.menu-list__link');
    links.forEach(link => {
      const listItem = link.closest('.menu-list__list-item');
      const hasSubmenu = listItem && listItem.querySelector('.menu-list__submenu');
      
      if (hasSubmenu && !link._clickAttached) {
        link.addEventListener('click', handleMenuClick, { capture: true });
        link._clickAttached = true;
      }
    });
  }

  // Close when clicking outside
  document.addEventListener('click', (e) => {
    if (!e.target.closest('.menu-list__list-item')) {
      document.querySelectorAll('.menu-list__list-item[aria-expanded="true"]').forEach(item => {
        item.removeAttribute('aria-expanded');
        const link = item.querySelector('.menu-list__link');
        if (link) link.setAttribute('aria-expanded', 'false');
        const submenu = item.querySelector('.menu-list__submenu');
        if (submenu) submenu.setAttribute('data-expanded', 'false');
        const headerMenu = item.closest('header-menu');
        if (headerMenu) {
            headerMenu.style.setProperty('--submenu-height', '0px');
            headerMenu.style.setProperty('--submenu-opacity', '0');
        }
      });
    }
  }, { capture: true });

  // Multiple initialization attempts to catch dynamic content
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  setTimeout(init, 500);
  setTimeout(init, 2000);
  window.addEventListener('resize', init);

  // Disable theme's overflow-list masking
  function disableOverflow() {
    document.querySelectorAll('overflow-list').forEach(list => {
      list.setAttribute('disabled', 'true');
      if (list.showAll) list.showAll();
    });
  }
  init();
  disableOverflow();
  setTimeout(disableOverflow, 1000);
})();
